export default [
  { to: 'organisation', title: 'Organisation' },
  { to: 'operativa_rutiner', title: 'Operativa rutiner' },
  { to: 'insatsstod', title: 'Insatsstöd' },
  { to: 'changelog', title: 'Info' },
  { to: 'arkiv', title: 'Arkiv' },
];
